var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 nyx-list-item py-1",class:{
 'nyx-list-item--active': _vm.isActive
}},[_c('div',{staticClass:"d-flex align-items-center justify-content-between my-2"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',[_c('div',{staticClass:"text__body--small text-is--dark"},[_vm._v(_vm._s(_vm.option.value))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }